import { fetchJSON }               from '../helpers/fetchTools';
import env                         from '../env';
import { UserSession }             from '../types';

interface NoobiePayload {
    code: number;
    success: boolean;
    details: {
        conversationNoobieUser: boolean;
    }
}

export const getNoobieStatus = (session: UserSession): Promise<NoobiePayload> => (fetchJSON(`${env.MESSAGE_LIST_HOST}/v1/rest/conversations/noobie/check`, {
    headers: new Headers({
        Authorization: `Bearer ${session.token}`
    }),
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache'
}));



// WEBPACK FOOTER //
// ./src/services/NoobieService.ts